import { LabelProps } from './types'
import { StyledLabel } from './styles'

export const Label = ({ children, required, portalContainer, ...restProps }: LabelProps) => (
  <StyledLabel {...restProps}>
    {children}
    {required && <span>*</span>}
  </StyledLabel>
)
